// extracted by mini-css-extract-plugin
module.exports = {"PlaneIcon":"PlaneIcon_PlaneIcon__3V_Wr","flipped":"PlaneIcon_flipped__3Vfcu"};